import { createTestIds } from '../../utils';
import { elements } from '../FormField/FormField.test-ids';

export const getInputTestIds = createTestIds('input', ['control', ...elements] as const);
